import { FieldValidatorType } from "@progress/kendo-react-form";

const regex = new RegExp(/[A-Za-z ]$/);

export const alphabeticValidator: FieldValidatorType = (value: string) =>
  regex.test(value)
    ? ""
    : "Il campo deve essere composto da caratteri alfabetici";
